import { render, staticRenderFns } from "./ItensEditModal.vue?vue&type=template&id=b0b947a8&scoped=true"
import script from "./ItensEditModal.vue?vue&type=script&lang=js"
export * from "./ItensEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b947a8",
  null
  
)

export default component.exports